import { Directive, ElementRef } from '@angular/core';
import { GlobalService } from '../services/global.service';

@Directive({
    selector: '[allowKeyboardFocus]'
})
export class allowKeyboardFocus {

    element: ElementRef;

    constructor(el: ElementRef, private globalService: GlobalService) {
        this.element = el;
        this.setTabindex();
        this.setAriaHidden();

        this.globalService.allowFocus.subscribe(
            () => {
                this.setTabindex();
                this.setAriaHidden();
            }
        );
    }

    setTabindex() {
        this.element.nativeElement.setAttribute("tabindex", this.globalService.getKeyboardPermission());
    }

    setAriaHidden() {
        this.element.nativeElement.setAttribute("aria-hidden", this.globalService.getSrPermission());
    }
}